import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaPowerOff, FaUser, FaBuilding } from "react-icons/fa";
import { getUserData, getFPOData, getUserFullName, getUserRole } from "../../helpers/local_storage_helpers";

const defaultAvatar = "https://ui-avatars.com/api/?background=2FB95D&color=fff&name=FPO";

function ProfileDropdown({ logout }) {
    const [userData, setUserData]       = useState({});
    const [fpoData, setFpoData]         = useState({});
    const [isDropdownOpen, setIsOpen]   = useState(false);
    const dropdownRef                   = useRef(null);
    const navigate                      = useNavigate();

    const toggleDropdown = () => setIsOpen((p) => !p);

    const handleLogout = () => {
        setIsOpen(false);
        logout();
    };

    const handleProfile = () => {
        setIsOpen(false);
        navigate("/profile");
    };

    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    useEffect(() => {
        setUserData(getUserData() || {});
        setFpoData(getFPOData() || {});
    }, []);

    const userRole = getUserRole() || "FPO Admin";

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                className="w-full flex items-center gap-2.5 px-2 py-2 rounded-xl hover:bg-white/10 transition-colors cursor-pointer select-none"
                onClick={toggleDropdown}
            >
                <div className="w-8 h-8 rounded-full bg-primary/20 border-2 border-primary/40 flex items-center justify-center overflow-hidden flex-shrink-0">
                    <img
                        src={defaultAvatar}
                        alt="Profile"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="flex-1 min-w-0 flex flex-col items-start leading-tight">
                    <span className="text-white text-xs font-semibold truncate w-full text-left">
                        {getUserFullName() || userData?.first_name || userData?.username || "FPO Admin"}
                    </span>
                    <span className="text-white/40 text-[10px] truncate w-full text-left capitalize">
                        {userRole.replace(/_/g, " ")}
                    </span>
                </div>
                <svg className="w-3.5 h-3.5 text-white/40 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isDropdownOpen && (
                <div className="absolute left-0 bottom-full mb-2 w-56 z-50 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
                    {/* User info header */}
                    <div className="px-4 py-3 bg-gradient-to-r from-primary/10 to-green-50 border-b border-gray-100">
                        <p className="text-sm font-bold text-gray-800">
                            {userData?.first_name} {userData?.last_name}
                        </p>
                        <p className="text-xs text-gray-500">{userData?.email || userData?.username}</p>
                        {fpoData?.name && (
                            <div className="flex items-center gap-1 mt-1">
                                <FaBuilding className="text-primary text-xs" />
                                <span className="text-xs text-primary font-semibold">{fpoData.name}</span>
                            </div>
                        )}
                    </div>

                    {/* Menu items */}
                    <div className="p-2">
                        <button
                            className="w-full px-3 py-2.5 text-left text-gray-700 hover:bg-primary/10 hover:text-primary rounded-xl flex items-center gap-3 transition-colors text-sm font-medium"
                            onClick={handleProfile}
                        >
                            <FaUser className="text-primary" />
                            FPO Profile
                        </button>

                        <div className="border-t border-gray-100 my-1" />

                        <button
                            className="w-full px-3 py-2.5 text-left text-red-600 hover:bg-red-50 rounded-xl flex items-center gap-3 transition-colors text-sm font-medium"
                            onClick={handleLogout}
                        >
                            <FaPowerOff />
                            Logout
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProfileDropdown;
